"use client";

import { useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SHOW_BANNER, BANNER_TEXT } from "@/planHelper";
import Link from "next/link";

export default function TopBanner() {
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = bannerRef.current;
    if (!el) return;

    const update = () => {
      document.documentElement.style.setProperty(
        "--banner-height",
        `${el.getBoundingClientRect().height}px`,
      );
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => {
      observer.disconnect();
      document.documentElement.style.setProperty("--banner-height", "0px");
    };
  }, []);

  if (!SHOW_BANNER) return null;

  return (
    <AnimatePresence>
      <Link href={"https://app.infinitcode.ai/login"} target="_blank">
        <motion.div
          ref={bannerRef}
          initial={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0, overflow: "hidden" }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="border-b-4 w-full border-b-[#16985f] bg-gradient-to-r from-[#3BCF8E] to-[#2DA771] fixed left-1/2 -translate-x-1/2 z-[900]"
        >
          <div className="flex items-center justify-center gap-3 px-4 py-3 relative">
            <span className="inline-flex items-center gap-2 max-md:text-[14px] text-lg text-white max-md:text-center">
              <span>
                <span className="font-bold text-white">{BANNER_TEXT.label}</span>{" "}
                {BANNER_TEXT.message}{" "}
                <span className="font-bold text-white">
                  {BANNER_TEXT.discountPrice}!
                </span>{" "}
                <span className="line-through text-white">
                  {BANNER_TEXT.originalPrice}
                </span>{" "}
                <span className="text-white italic">{BANNER_TEXT.tag}</span>
              </span>
            </span>
          </div>
        </motion.div>
      </Link>
    </AnimatePresence>
  );
}
